import React, { useContext } from "react";
import {
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Card,
  ListItem,
  List,
} from "@material-ui/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../Context/Langcontext";
import { useSnackbar } from "notistack";
import Tooltips from "@material-ui/core/Tooltip";

const useStyle = makeStyles((theme) => ({
  texthead: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 700,
  },
  tablecell: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 200,
  },
  iconbtn: {
    width: "2rem",
    height: "auto",
    transition: "transform .2s",
    "&:hover": {
      transform: "scale(1.5)",
    },
  },
  tbcontain: {
    boxShadow: "unset",
    border: "2px solid #F0F0EA",
  },
  maintext: {
    fontWeight: 700,
    // fontSize: "1.2rem",
    color: "#595A5A",
    textAlign: "left",
  },
  export: {
    textTransform: "unset",
  },
  gridend: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "1rem",
  },
  cardtooltip: {
    margin: "1rem",
    display: "flex",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    zIndex: 99999,
    backgroundColor: "#ffffff87",
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
  },
  fonttooltip: {
    fontSize: "0.7rem",
    fontWeight: 400,
    color: "#E16733",
  },
  fontlabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#595A5A",
  },
}));

const Barchartperm = ({ genPDF, setsize, data }) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { enqueueSnackbar } = useSnackbar();

  const NoData = [{ name: lang.NotFound, usage: 0 }];

  const renderTooltip = (props) => {
    let { payload } = props;
    if (props.active) {
      return (
        <Card className={classes.cardtooltip}>
          <List>
            {payload.map((entry, index) => {
              return (
                <ListItem key={`${entry.dataKey}_${index}`}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography className={classes.fontlabel}>
                        {entry.payload.name}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Typography className={classes.fonttooltip}>
                        {`${lang.Usage} : ${entry.value.toLocaleString()}`}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </Card>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.maintext}>
          {lang.MonthlyUsage}
        </Typography>
        <div style={{ margin: "1rem" }}>
          <Grid container spacing={0} justify="center">
            <div style={{ width: "80%", height: 320 }}>
              <ResponsiveContainer>
                <BarChart
                  data={data.length ? data : NoData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip content={renderTooltip} />
                  <Bar
                    dataKey="usage"
                    fill="#E16733"
                    barSize={data.length < 3 ? 50 : 30}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12}>
        <TableContainer className={classes.tbcontain} component={Paper}>
          <Table aria-label="spanning table" size="small">
            <TableHead style={{ backgroundColor: "#f9f9f9" }}>
              <TableRow>
                <TableCell
                  align="center"
                  className={classes.texthead}
                  style={{ borderRight: "1px solid #e3e3e3" }}
                >
                  {lang.Month}
                </TableCell>
                <TableCell align="center" className={classes.texthead}>
                  {lang.Request}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow
                  key={row.name}
                  style={{
                    backgroundColor: index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                  }}
                >
                  <TableCell
                    align="center"
                    className={classes.tablecell}
                    style={{ borderRight: "1px solid #e3e3e3" }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell align="center" className={classes.tablecell}>
                    {row.usage.toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={12} className={classes.gridend}>
        <Tooltips title="คลิกเพื่อนำออก PDF" placement="top">
          <Button
            startIcon={
              <img
                alt="export_pdf"
                src={require("../../images/graphic-icon/export_pdf.png")}
                className={classes.iconbtn}
              />
            }
            className={classes.export}
            onClick={() => {
              setsize(true);
              enqueueSnackbar("Exporting pdf ... ", {
                variant: "success",
              });
              setTimeout(() => {
                genPDF();
              }, 5000);
            }}
          >
            {`${lang.Export} PDF`}
          </Button>
        </Tooltips>
      </Grid>
    </>
  );
};

export default Barchartperm;
